import { Box } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { AddOrderButton } from '@planning/components/AddOrderButton'
import { ListHeader } from '@planning/components/list/ListHeader'
import { useOrderNavigation } from '@planning/hooks/useOrderNavigation'
import { containerService } from '@planning/services'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FC, useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { ContainerYardOperationViewStore } from '../VesselVisit/Components'
import { SearchContainerJourneyVisit } from './components/SearchContainerJourneyVisit'
import { RenderIsoCodeMappingInputFn } from './stores/IsoCodeMappingInputStore'
import { BaplieParseResult } from './stores/OrderListUploadParsingStore'

export interface IOrdersPage {
  renderIsoCodeMappingInput?: RenderIsoCodeMappingInputFn
  containerYardOperationViewStore: ContainerYardOperationViewStore
  parseBaplie?: (file: File) => Promise<BaplieParseResult>
}

export const OrdersPage: FC<IOrdersPage> = observer(
  ({ renderIsoCodeMappingInput, containerYardOperationViewStore, parseBaplie }) => {
    const {
      containerAutocompleteStore,
      orderListStore,
      selectOrderViewStore,
      isoCodeMappingInputStore,
    } = usePlanningStore()
    const { t } = useTranslate()

    containerAutocompleteStore.setIncludeRestow(true)

    const { containerNumber } = useParams()

    const [isInitialized, setIsInitialized] = useState(false)

    isoCodeMappingInputStore.renderIsoCodeMappingInput = renderIsoCodeMappingInput

    const { navigateJourneyOrderPage } = useOrderNavigation()

    const resetStores = useCallback(() => {
      containerAutocompleteStore.reset()
      selectOrderViewStore.reset()
      selectOrderViewStore.containerJourneyDataStore.reset()
      orderListStore.reset()
    }, [containerAutocompleteStore, orderListStore, selectOrderViewStore])

    useEffect(() => {
      resetStores()
    }, [resetStores])

    useEffect(() => {
      if (containerNumber) {
        containerAutocompleteStore.setFilter(containerNumber)
        containerService
          .getContainersByPartialNumber(
            containerNumber,
            undefined, // isEmpty
            undefined, // hasServiceOrders
            undefined, // canAssignServiceOrders
            undefined, // type
            undefined, // isoCode
            undefined, // isOnTerminal
            undefined, // operator
            true,
          )
          .then(c => {
            if (c.length > 0) {
              selectOrderViewStore.selectContainer(c[0])
              if (
                c[0].id &&
                selectOrderViewStore.containerJourneyDataStore.items[0]?.containerId !== c[0].id
              ) {
                selectOrderViewStore.containerJourneyDataStore.fetch({
                  containerId: c[0].id,
                  activeOrderIds: [],
                  includeCompleted: false,
                  includeUnlinkedOutboundOrders: false,
                })
              }
            }
          })
        orderListStore.setFilter(containerNumber)
      }

      setIsInitialized(true)
    }, [
      containerAutocompleteStore,
      containerNumber,
      orderListStore,
      resetStores,
      selectOrderViewStore,
    ])

    if (!containerNumber && !selectOrderViewStore.containerJourneyDataStore.items) resetStores()

    return isInitialized ? (
      <Box padding='1rem'>
        <ListHeader
          title={t('containers', 'Containers')}
          actions={[
            <AddOrderButton
              key='addOrderButton'
              color='primary'
              onClick={() =>
                navigateJourneyOrderPage({
                  returnPathAdditionalParams: {
                    containerNumber: true,
                  },
                })
              }
            />,
          ]}
        />

        <SearchContainerJourneyVisit
          searchStore={containerAutocompleteStore}
          listStore={selectOrderViewStore.containerJourneyDataStore}
          viewStore={selectOrderViewStore}
          showHavingOpenOrdersWarning={false}
          onReset={resetStores}
          containerYardOperationViewStore={containerYardOperationViewStore}
        />
      </Box>
    ) : (
      <></>
    )
  },
)
